import { appendTestableComponentAttributes, StandardSpinner } from '@dreryk/react-components';
import { useTranslate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { StyledProcessingIndicatorContainer, StyledProcessingMessage } from './ProcessingIndicator.styled';

type ProcessingIndicatorProps = {
   /**
    * When true, a screen-reader message announces that fields are locked.
    * The parent is responsible for actually disabling the editors.
    */
   fieldsLocked?: boolean;
};

export const ProcessingIndicator = (props: ProcessingIndicatorProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledProcessingIndicatorContainer
         {...appendTestableComponentAttributes('ProcessingIndicator', 'processingIndicator')}
         role='status'
         aria-live='polite'
         aria-atomic='true'
         aria-label={translate(translationKeys.processingIndicator.message)}
      >
         <StandardSpinner />
         <StyledProcessingMessage>{translate(translationKeys.processingIndicator.message)}</StyledProcessingMessage>
         {props.fieldsLocked ? (
            <span className='sr-only' aria-live='polite'>
               {translate(translationKeys.processingIndicator.fieldsLocked)}
            </span>
         ) : null}
      </StyledProcessingIndicatorContainer>
   );
};
